<template>
  <div class="flex flex-col-reverse items-end justify-center mr-auto">
    <Number
      #="{ number }"
      :value="(symbol.referencePriceVariationPercentage ?? 0) / 100"
      sign-display="always"
      maximum-fraction-digits="2"
      number-style="percent"
    >
      <NText
        dir="ltr"
        class="mr-2"
        :class="{
          'text-neutral-secondary': !(
            symbol.referencePriceVariationPercentage ?? 0
          ),
          'text-critical-primary':
            (symbol.referencePriceVariationPercentage ?? 0) < 0,
          'text-brand-primary':
            (symbol.referencePriceVariationPercentage ?? 0) > 0,
        }"
        data-testid="percentage-number"
        weight="bold"
        variant="caption1"
      >
        {{ number }}
      </NText>
    </Number>

    <NPopper hover>
      <span>
        <Number #="{ number }" :value="symbol.lastTradePrice ?? 0">
          <ChangePriceEffect :price="symbol.lastTradePrice ?? 0">
            <NText
              :key="number"
              :variant="priceVariant"
              weight="bold"
              class="mr-2 text-h3"
            >
              {{ number }}
            </NText>
          </ChangePriceEffect>
        </Number>
      </span>

      <template #content>
        <div
          class="flex justify-center bg-neutral-quaternary py-1 rounded-md w-20"
        >
          <NText
            weight="medium"
            variant="caption2"
            class="text-neutral-quaternary"
          >
            {{ t('symbol.last_trade_price') }}
          </NText>
        </div>
      </template>
    </NPopper>

    <NText
      v-if="showCurrency"
      variant="subtitle"
      weight="medium"
      class="text-neutral-secondary mr-2"
    >
      {{ t('misc.rial') }}
    </NText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Instrument } from '@libs/api-reference';

import Number from '@/components/Number.vue';
import ChangePriceEffect from '@/components/ChangePriceEffect.vue';

type SymbolLastPriceProps = {
  symbol: Instrument;
  showCurrency?: boolean;
  priceVariant?: 'body' | 'h2';
};

withDefaults(defineProps<SymbolLastPriceProps>(), {
  showCurrency: true,
  priceVariant: 'h2',
});

const { t } = useI18n();
</script>
